// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d8095220","421":"dfe1f01c","977":"959a3d70"}[chunkId] + ".chunk.js";
};